export const LOCALSTORAGE_KEYS = {
  LANG: 'lang',
  PAYPAL: 'paypal',
  CHARGE_ID: 'chargeId',
};
